export const deploymentConfigs = {
  'finportfolio-service': {
    service_name: 'FinPortfolioService',
    aws_region: 'ap-south-1',
    artifact_bucket: 'deployment-artifacts-940420096299',
    deployment_lambda_arn:
      'arn:aws:lambda:ap-south-1:940420096299:function:FinPortfolioServiceStack-FinPortfolioServiceDeploy-TxrDVumQYAPK',
    canary_lambda_arn:
      'arn:aws:lambda:ap-south-1:940420096299:function:FinportfolioCanaryTestSta-CanaryTestLambda95CF6DE1-kU4CWqiUGu2l',
    service_health_endpoint: '/api/ping',
    environments: {
      prod: {
        api_gateway_url: 'https://finportfolio.krezin.com'
      }
    },
    github_source: {
      config_table: 'FinPortfolioService_Config',
      config_partition: 'SERVICE',
      parameter_prefix: '/finportfolio-service',
      expected_repository: 'TradeFocus/FinportfolioWorkspace',
      package_path: 'packages/FinPortfolio'
    }
  }
};

export const CLOUDWATCH_CONFIG = {
  LOG_GROUP_ARN:
    'arn:aws:logs:ap-south-1:940420096299:log-group:/aws/lambda/deployment-orchestrator-deployment-lambda',
  AWS_REGION: 'ap-south-1'
};
